import { render } from "./JotformData.vue?vue&type=template&id=f41df57a"
import script from "./JotformData.vue?vue&type=script&lang=ts"
export * from "./JotformData.vue?vue&type=script&lang=ts"
script.render = render

export default script